import { PlatformOS } from 'root-constants'

export function getMobileOperatingSystem(
  withMacOs: boolean = false,
): PlatformOS {
  const { userAgent } = window.navigator
  if (/android/i.test(userAgent)) {
    return PlatformOS.ANDROID
  }
  if (
    (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) ||
    // for ipad > 13 ios
    (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
  ) {
    return PlatformOS.IOS
  }

  if (withMacOs) {
    const macosPlatforms = /(macintosh|macintel|macppc|mac68k|macos)/i
    const isMac = macosPlatforms.test(userAgent)
    const noTouch = navigator.maxTouchPoints === 0
    if (isMac && noTouch) {
      return PlatformOS.MAC_OS
    }
  }
  return PlatformOS.UNKNOWN
}
